import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gvnnnu5bqh: FaireBrandEntity = {
  token: "b_gvnnnu5bqh",
  type: "brand",
  name: "Cotton Socks",
  avatarUrl:
    "https://cdn.faire.com/fastly/fd400dce2902d4255455b57c848e437cfd20298c8aff66aec701276a9e765e8c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2728b11f65a2e416f57e0d3b00fe0f81ecba9549b246e92e3ba62fbd49875dd1.png",
  logoUrl:
    "https://cdn.faire.com/fastly/fd400dce2902d4255455b57c848e437cfd20298c8aff66aec701276a9e765e8c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2728b11f65a2e416f57e0d3b00fe0f81ecba9549b246e92e3ba62fbd49875dd1.png",
  location: "PRT",
  minimumOrderDollars: 117,
  rating: 4.9,
  reviewCount: 83,
  isTopShop: true,
  isInsider: false,
  description:
    "Cotton Socks is a Portuguese brand of high-quality products that meet the needs of the general market, as well as market segments with specific needs.\n\nWe began our adventure in 1998 to develop the healthiest and most practical products. It was our experience as a father and mother that inspired us in the creation of each piece in our collections.\n\nWe want the best for our children, so every day we work with love and dedication to develop natural products without dyes or chemicals. All our pieces are produced in Portugal.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:00.073Z",
    importedBy: "entity-db-cli",
  },
};
